import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconGridSvg } from "./IconGridSvg.mjs";
const IconGrid = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconGridSvg, ...svgProps }) });
export {
  IconGrid
};
